"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Can", {
  enumerable: true,
  get: function get() {
    return _Can.default;
  }
});
Object.defineProperty(exports, "Cannot", {
  enumerable: true,
  get: function get() {
    return _Cannot.default;
  }
});
exports.default = void 0;

var _Can = _interopRequireDefault(require("./Can"));

var _Cannot = _interopRequireDefault(require("./Cannot"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable-next-line */
var _default = _Can.default;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@contently/toolkit/dist/containers/can/index.js
// module id = 669
// module chunks = 0 15 16 17 18